<template>
  <app-content>
    <pairing-detail-dialog
        v-if="detailItem"
        :item="detailItem.pairingDetails"
        @refreshDetailItem="refreshDetailItem"
    />
    <app-content-body>
      <div class="inner">
        <h1 v-translate>TV program</h1>
      </div>

      <div class="inner_white">
        <div class="filter">
          <app-table-header-item class="field_left">
            <app-input
                :label="translations.search"
                type="search"
                v-model="params.search"
                @input="filterBroadcasts()"
            />
            <app-checkbox
                name="fulltextSearch"
                title="Zpřísnit kritéria vyhledávání"
                v-model="fulltextSearch"
            />
          </app-table-header-item>
          <app-table-header-item class="field_right">
            <app-table-header-select :label="translations.createdBy">
              <app-select
                  id="createdBy"
                  :options="createdOptions"
                  selectId="createdSelect"
                  name="createdSelect"
                  v-model="createdSelect"
              />
            </app-table-header-select>

            <p><app-checkbox
                name="railBroadcasts"
                :title="translations.railBroadcasts"
                v-model="railBroadcasts"
              />
            </p>
          </app-table-header-item>

          <app-table-header-item class="field_left">
              <div class="field field_search">
                <label for="skupinyStanic">Skupiny stanic</label>
                <select name="skupinyStanic" id="skupinyStanic" v-model="selectedTvStationGroup" @change="this.onTvStationGroupSelected">
                  <option value="all">Všechny</option>
                  <option value="epgPlus">EPG plus</option>
                  <option value="epgRest">EPG rest</option>
                  <option
                    v-for="tvStationGroup in tvStationGroups"
                    :key="tvStationGroup._id"
                    v-bind:value="tvStationGroup._id"
                  >
                    {{ tvStationGroup.name }}
                  </option>
                </select>
              </div>
            </app-table-header-item>
            <app-table-header-item class="field_right">
              <app-table-header-select :label="translations.from">
                <app-date-since
                    :currentTimestamp="currentTimestamp"
                    :start-date="pickerStartDate"
                    :end-date="pickerEndDate"
                    @dateChanged="onDateChanged"
                    @hourChanged="onHourChanged"
                    @resetTime="resetTime"
                />
              </app-table-header-select>
            </app-table-header-item>

            <dropdown-input
              :label="'Stanice'"
              :options="tvStationAutocompleteData"
              :selected="selectedTvStations.map(selectedTvStation => this.getTvStationLabelText(selectedTvStation))"
              :visibleResultLimit="10"
              @seeMoreClicked="seeAllTvStations"
              @autocompleteValueChanged="onTvStationSelected"
              @removeItem="removeTvStation"
              @removeAll="removeAllTvStations"
            />

          <app-table-header-item class="field_left field_full">
            <p class="field checkbox_label">Stav vysílání</p>
            <div class="field checkboxes">
              <p class="field">
                <app-checkbox
                    key="stavVysilani1"
                    name="stavVysilani1"
                    title="Vysílání navázaná na pořady"
                    :value="broadcastStateCheckbox1.checked"
                    :checked="broadcastStateCheckbox1.checked"
                    :tv-program-filtration="true"
                    :green="true"
                    @change="onBroadcastStateCheckboxChanged(broadcastStateCheckbox1, $event)"
                />
              </p>
              <p class="field">
                <app-checkbox
                    key="stavVysilani2"
                    name="stavVysilani2"
                    title="Vysílání navázaná na pořady, je třeba kontrola"
                    :value="broadcastStateCheckbox2.checked"
                    :checked="broadcastStateCheckbox2.checked"
                    :tv-program-filtration="true"
                    :orange="true"
                    @change="onBroadcastStateCheckboxChanged(broadcastStateCheckbox2, $event)"
                />
              </p>
              <p class="field">
                <app-checkbox
                    key="stavVysilani3"
                    name="stavVysilani3"
                    title="Vysílání navázaná na dočasné pořady"
                    :value="broadcastStateCheckbox3.checked"
                    :checked="broadcastStateCheckbox3.checked"
                    :tv-program-filtration="true"
                    :red="true"
                    @change="onBroadcastStateCheckboxChanged(broadcastStateCheckbox3, $event)"
                />
              </p>
            </div>
          </app-table-header-item>
        </div>
        <program-item
            v-for="(item) in items"
            :key="item._id"
            :item="item"
            :labels="labelsMap"
            :countries="countries"
            @delete="deleteItem($event)"
            @openPairingDetails="selectDetailItem"
        />
        <div class="action_line" v-if="numberOfBroadcasts > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="numberOfBroadcasts"
              @pageChanged="tablePageChanged"
          />
        </div>
      </div>

      <tv-station-filter-popup
        v-if="seeAllTvStationsShown"
        :tvStations="selectedTvStations"
        @tvStationsSelected="setSelectedTvStations"
        @close="closeSeeAllTvStations"
      />
    </app-content-body>
  </app-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import ProgramItem from 'components/TvProgram/ProgramItem'
import appTitleMixin from '../mixins/appTitleMixin'
import getItemsListMixin from 'mixins/getItemsListMixin'
import PairingDetailDialog from 'components/PairingDetailDialog'
import { AUTOCOMPLETE_TITLE } from 'symbols/autocomplete'
import DropdownInput from 'components/DropdownInput'
import TvStationFilterPopup from '../components/Filter/TvStationFilterPopup.vue'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Broadcasts',
  preventFetchOnCreated: true
})

export default {
  name: 'tv-program',
  mixins: [itemsListMixin, appTitleMixin()],
  components: {
    PairingDetailDialog,
    ProgramItem,
    DropdownInput,
    TvStationFilterPopup
  },
  created() {
    this.getCountries()
    this.params.generated = true

    if (this.params.tvStationGroup) {
      this.selectedTvStationGroup = this.params.tvStationGroup
    }

    if (this.params.createdBy) {
      this.createdSelect = this.params.createdBy
    }

    if (this.params.fromTimestamp) {
      this.currentTimestamp = moment.unix(this.params.fromTimestamp)
    } else {
      this.currentTimestamp = moment()
    }
    if (this.params.fulltextSearch !== undefined && this.params.fulltextSearch !== null) {
      this.fulltextSearch = this.params.fulltextSearch
    } else {
      this.fulltextSearch = true
    }

    if (this.params.railBroadcasts !== undefined && this.params.railBroadcasts !== null) {
      this.railBroadcasts = this.params.railBroadcasts
    } else {
      this.railBroadcasts = false
    }

    this.getLabelsForCurrentLanguage()
    this.getTvStationGroups({ params: { order: 'custom' } })
    this.getTvStations({ params: { order: 'name', countUnassignedBroadcasts: true, broadcastsFilter: this.params } })
    this.filterBroadcasts(true)
    this.broadcastStateCheckbox1 = {
      checked: this.params.state.includes('BROADCAST_STATE_VERIFIED'),
      value: 'BROADCAST_STATE_VERIFIED'
    }
    this.broadcastStateCheckbox2 = {
      checked: this.params.state.includes('BROADCAST_STATE_UNVERIFIED'),
      value: 'BROADCAST_STATE_UNVERIFIED'
    }
    this.broadcastStateCheckbox3 = {
      checked: this.params.state.includes('BROADCAST_STATE_UNASSIGNED'),
      value: 'BROADCAST_STATE_UNASSIGNED'
    }
  },
  data() {
    return {
      detailItem: null,
      createdSelect: '',
      currentTimestamp: null,
      broadcastStateCheckbox1: null,
      broadcastStateCheckbox2: null,
      broadcastStateCheckbox3: null,
      selectedTvStationGroup: 'all',
      selectedTvStations: [],
      seeAllTvStationsShown: false,
      fulltextSearch: null,
      railBroadcasts: null,
      dataPending: false
    }
  },
  computed: {
    ...mapState({
      countries: state => state.countries.countries,
      tvStationGroups: state => state.tvStationGroups.tvStationGroups,
      tvStations: state => state.tvStations.tvStations,
      labels: state => state.labels.labels,
      labelsPending: state => state.labels.pending.labels,
      broadcastOverview: state => state.broadcasts.broadcastOverview,
      currentLanguageId: state => state.uiLanguages.currentLanguageId
    }),
    createdOptions() {
      return [
        { name: this.translations.none, value: '' },
        { name: this.translations.automatically, value: 'AUTOMATICALLY' },
        { name: this.translations.manually, value: 'MANUALLY' }
      ]
    },
    numberOfBroadcasts() {
      return this.itemsMetadata.totalCount
    },
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        createdBy: this.$gettext('Navázaný pořad vytvořen'),
        from: this.$gettext('Od'),
        currentTime: this.$gettext('Aktuální čas'),
        none: this.$gettext('Nevybráno'),
        automatically: this.$gettext('Automaticky'),
        manually: this.$gettext('Manuálně'),
        railBroadcasts: this.$gettext('Pouze Rail broadcasty'),
      }
    },
    labelsMap() {
      return this.labels.reduce((obj, v) => {
        obj[v._id] = v.labelName
        return obj
      }, {})
    },
    pickerStartDate() {
      if (!this.broadcastOverview.groups) {
        return moment().toISOString()
      }
      return this.broadcastOverview.groups.find(v => v.groupType === 'archive').fromTimestamp
    },
    pickerEndDate() {
      if (!this.broadcastOverview.groups) {
        return moment().toISOString()
      }
      return this.broadcastOverview.groups.find(v => v.groupType === 'imported').toTimestamp
    },
    currentTitle() {
      return [
        this.$gettext('TV program')
      ]
    },
    tvStationAutocompleteData() {
      return this.tvStations.reduce((result, tvStation) => {
        let accept = false
        if (!this.selectedTvStations.includes(tvStation)) {
          if (this.selectedTvStationGroup == 'all') {
            accept = true
          } else if (this.selectedTvStationGroup == 'epgPlus') {
            accept = (tvStation.type == 'TV_STATION_EPG_PLUS')
          } else if (this.selectedTvStationGroup == 'epgRest') {
            accept = (tvStation.type == 'TV_STATION_EPG_REST')
          } else {
            accept = tvStation.tvStationGroupIds.includes(this.selectedTvStationGroup)
          }

          if (accept) {
            tvStation[AUTOCOMPLETE_TITLE] = this.getTvStationLabelText(tvStation)

            result.push(tvStation)
          }
        }

        return result
      }, [])
    }
  },
  methods: {
    ...mapActions(['getLabels', 'getCountries', 'getTvStationGroups', 'getTvStations']),
    selectDetailItem(item) {
      this.detailItem = item
    },
    refreshDetailItem() {
      this.detailItem = null
    },
    onBroadcastStateCheckboxChanged(item) {
      const state = this.params.state === '' ? [] : this.params.state.split(',')
      if (item.checked) {
        item.checked = false
        const index = state.indexOf(String(item.value))
        if (index > -1) {
          state.splice(index, 1)
        }
        this.params.state = state.length > 1 ? state.join(',') : state.length === 1 ? state[0] : ''
      } else {
        item.checked = true
        state.push(item.value)
        this.params.state = state.length > 1 ? state.join(',') : state[0]
      }
      this.filterBroadcasts()
    },
    resetTime() {
      this.currentTimestamp = moment()
    },
    onDateChanged(date) {
      const tempHours = this.currentTimestamp.hours()
      this.currentTimestamp = moment(date).hours(tempHours)
    },
    onHourChanged(hour) {
      this.currentTimestamp = this.currentTimestamp.clone().hours(hour)
    },
    getFromTimestamp(date) {
      return date.minutes(0).seconds(0).toISOString().slice(0, -5) + '+00:00'
    },
    shouldConfirmDelete() {
      return false
    },
    onTvStationGroupSelected(event) {
      if (this.selectedTvStationGroup !== 'all') {
        this.params.tvStationGroup = this.selectedTvStationGroup
      } else {
        this.params.tvStationGroup = null
      }
      this.filterBroadcasts()
    },
    onTvStationSelected(tvStationId, tvStation) {
      this.selectedTvStations.push(tvStation)
      this.params.tvStations = this.getTvStationRequestFilter()
      this.filterBroadcasts()
    },
    removeTvStation(tvStationLabel) {
      this.selectedTvStations = this.selectedTvStations.filter(tvStation => this.getTvStationLabelText(tvStation) !== tvStationLabel)
      this.params.tvStations = this.getTvStationRequestFilter()
      this.filterBroadcasts()
    },
    removeAllTvStations() {
      this.selectedTvStations = []
      this.params.tvStations = null
      this.filterBroadcasts()
    },
    getLabelsForCurrentLanguage() {
      this.getLabels({
        params: {
          idLanguage: this.currentLanguageId
        }
      })
    },
    async filterBroadcasts(created = false) {
      if (created) {
        this.dataPending = true
        const result = await this.fetchItems(true).then((res) => {
          this.dataPending = false
        })
      } else if (this.dataPending) {
        return
      } else {
        this.fetchItems(true)
        this.getTvStations({ params: { order: 'name', countUnassignedBroadcasts: true, broadcastsFilter: this.params } })
      }
      this.tablePageChanged(1, false)
    },
    getTvStationLabelText(tvStation) {
      return tvStation.name + ' (' + tvStation.broadcastsCount + ')'
    },
    getTvStationRequestFilter() {
      return this.selectedTvStations.map(tvStation => tvStation._id).join(',')
    },
    seeAllTvStations() {
      this.seeAllTvStationsShown = true
    },
    closeSeeAllTvStations() {
      this.seeAllTvStationsShown = false
    },
    setSelectedTvStations(tvStations) {
      this.seeAllTvStationsShown = false
      this.selectedTvStations = tvStations
      this.filterBroadcasts()
    }
  },
  watch: {
    createdSelect() {
      this.params.createdBy = this.createdSelect
      this.filterBroadcasts()
    },
    currentTimestamp(date) {
      this.params.fromTimestamp = moment(this.currentTimestamp).startOf('hour').format('X')
      this.filterBroadcasts()
    },
    currentLanguageId() {
      this.getLabelsForCurrentLanguage()
    },
    tvStations(old, newValue) {
      if (this.params.tvStations) {
        const tvStationFilterIds = this.params.tvStations.split(',')

        this.selectedTvStations = this.tvStations.filter((tvStation) => {
          return tvStationFilterIds.includes('' + tvStation._id)
        })
      }
    },
    fulltextSearch(value) {
      this.params.fulltextSearch = value
      this.filterBroadcasts()
    },
    railBroadcasts(value) {
      this.params.railBroadcasts = value
      this.filterBroadcasts()
    }
  }
}
</script>
